@if (anyItems) {
  <app-summary [model$]="observableModel" [summaryItems]="summaryItems.bind(this)"></app-summary>
}
